import { render, staticRenderFns } from "./MessageCreateView.vue?vue&type=template&id=94dd25c8&scoped=true"
import script from "./MessageCreateView.vue?vue&type=script&lang=js"
export * from "./MessageCreateView.vue?vue&type=script&lang=js"
import style0 from "./MessageCreateView.vue?vue&type=style&index=0&id=94dd25c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dd25c8",
  null
  
)

export default component.exports